<template>
  <div class="report-table">
    <base-table class="report-table__table" :columns="columns">
      <tr v-for="row in data" :key="row.id">
        <td
          v-for="column in columns"
          :key="`cell-${column.label}`"
          v-html="row[column.value]"
        />
      </tr>
    </base-table>

    <div class="report-table__bottom">
      <base-buttom outline @click="getCSV"
        ><icon-download class="report-table__download-icon" /> Export to
        CSV</base-buttom
      >
    </div>
  </div>
</template>

<script>
import IconDownload from "@components/svg/IconDownload.vue";
import BaseButtom from "@components/common/BaseButton.vue";
import BaseTable from "@components/common/BaseTable.vue";

import json2csv from "@utils/JSONToCSV.js";

export default {
  name: "AdminReportTable",
  components: { BaseTable, BaseButtom, IconDownload },
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] }
  },

  methods: {
    getCSV() {
      json2csv(this.columns, this.data).then(csv => {
        const exportedFileName = "report.csv";
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", exportedFileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    }
  }
};
</script>

<style>
.report-table {
  display: flex;
  flex-direction: column;
}

.report-table__bottom {
  padding-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

.report-table__table {
  overflow: auto;
}

.report-table__table th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: white;
}

.report-table__download-icon {
  height: 16px;
  width: 16px;
  margin-right: 0.5rem;
}
</style>
